import { memo } from "react";
import z from "zod";
import { withForm } from "@/hooks/useForm";
import { convertToBest } from "@/lib/utils";
import { TableRow, TableCell } from "@/components/ui/table";
import type { ExtendedInputacion } from "./InputTable";

interface InputRowProps {
	index: number;
	row: ExtendedInputacion["lineas"][number];
}
const InputRow = withForm({
	defaultValues: {} as ExtendedInputacion,
	props: {} as InputRowProps,
	render: function Render({ form, row, index }) {
		const conversion = (row.factor?.conversion_equivalente_kilos ?? 0) * 1000;
		const gramos = (row.cantidad ?? 0) * conversion;

		return (
			<TableRow>
				<TableCell>{row.factor?.nombre}</TableCell>
				<TableCell>{row.descripcionReferencia}</TableCell>
				<TableCell>
					<form.AppField
						name={`lineas[${index}].cantidad`}
						validators={{ onChange: z.number() }}
						children={(field) => (
							<field.NumberField unit={row.factor?.unidad ?? ""} />
						)}
					/>
				</TableCell>
				<TableCell>{convertToBest(gramos, "g")}</TableCell>
			</TableRow>
		);
	},
});
export const InputRowMemo = memo(InputRow);
